/* eslint-disable indent */
import { TasklistService } from '@/api/tasklist'
import { Button, Spinner } from 'alurkerja-ui'
import { X } from 'lucide-react'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import TableVariable from '@/components/tasklist/TableVariable'
import HistoryTask from '@/components/tasklist/tasks/HistoryTask'
import DiagramTask from '@/components/tasklist/tasks/DiagramTask'

export default function ModalDetailRequest() {
  const [activeTab, setActiveTab] = useState('diagram')
  const activeClassName = `text-main-blue-alurkerja bg-blue-50 border-b border-main-blue-alurkerja`
  const { processKey, id } = useParams()
  const navigate = useNavigate()

  const { data: request, isFetching } = TasklistService.useGetTask({
    processDefinition: processKey!,
    taskId: id!,
  })

  const getBack = () => {
    navigate(-1)
  }

  const handleClickTab = (tab: string) => {
    setActiveTab(tab)
  }

  return (
    <div className="flex justify-center items-start fixed top-0 left-0 w-screen h-screen bg-black/[.50] z-40 pt-0 sm:pt-10 overflow-y-auto">
      <div className="w-screen min-h-screen sm:min-h-min sm:w-[600px] md:w-[800px] p-2 sm:p-6 bg-white rounded-lg space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-lg font-semibold">Detail Request</h1>
          <Button
            data-testid="close-modal-button"
            className="bg-red-50 hover:bg-red-200"
            size="small"
            onClick={getBack}
            icon={<X color="red" />}
          ></Button>
        </div>
        <div className="tab-group">
          {/* tab */}
          <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-y border-gray-200">
            <li className="me-2">
              <button
                className={`inline-block p-4 hover:text-gray-600 hover:bg-gray-50 hover:cursor-pointer ${
                  activeTab === 'detail' ? activeClassName : ''
                }`}
                onClick={() => handleClickTab('detail')}
              >
                Detail
              </button>
            </li>
            <li className="me-2">
              <button
                className={`inline-block p-4 hover:text-gray-600 hover:bg-gray-50 hover:cursor-pointer ${
                  activeTab === 'history' ? activeClassName : ''
                }`}
                onClick={() => handleClickTab('history')}
              >
                History
              </button>
            </li>
            <li className="me-2">
              <button
                className={`inline-block p-4 hover:text-gray-600 hover:bg-gray-50 hover:cursor-pointer ${
                  activeTab === 'diagram' ? activeClassName : ''
                }`}
                onClick={() => handleClickTab('diagram')}
              >
                Diagram
              </button>
            </li>
          </ul>

          {/* tab content */}
          <div className="p-4">
            <div hidden={activeTab != 'detail'}>
              {isFetching && <Spinner />}
              {request && <TableVariable variables={request?.variables as Record<string, any>} />}
            </div>

            {request && (
              <>
                <HistoryTask show={activeTab === 'history'} history={request?.instance_history} />

                <DiagramTask
                  show={activeTab === 'diagram'}
                  processKey={request?.process_definition_id}
                  taskKey={request?.task_definition_key}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
